// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__hY3cL","icon":"styles_icon__wv4Pc","iconTransformed":"styles_iconTransformed__6zYaw"};
module.exports.__checksum = "052d539a6f93"